module.exports = __webpack_public_path__ + "img/c94.a0ffd7e8.png";